import React from 'react'
import { Checkbox, List, Tag } from 'antd'
import styled from 'styled-components'
import { calculateSellingPriceInclVatFormatted } from 'src/utils/vatCalculations'
import { formatGbp } from 'src/utils/formatGbp'
import RecipeGpBadge from './RecipeGpBadge'
import { isRecipeArchived } from 'src/utils/recipeMonitoring'

const formatMoney = value => {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed.toFixed(2) : '0.00'
}

const AddRecipePickerListItem = ({ recipe, checked, onCheckedChange }) => {
  const sellingDisplay =
    calculateSellingPriceInclVatFormatted(
      recipe?.sellingPrice,
      recipe?.hasVat,
    ) || formatMoney(recipe?.sellingPrice)

  return (
    <List.Item>
      <Checkbox checked={checked} onChange={onCheckedChange}>
        <Row>
          <Thumb>
            {recipe?.image ? (
              <ThumbImage src={recipe.image} alt='' />
            ) : (
              <ThumbPlaceholder>No photo</ThumbPlaceholder>
            )}
          </Thumb>
          <Body>
            <TitleRow>
              <Title>{recipe?.title}</Title>
              {recipe?.category?.name ? (
                <Tag style={{ margin: 0 }}>{recipe.category.name}</Tag>
              ) : null}
              {isRecipeArchived(recipe) ? null : (
                <RecipeGpBadge grossProfit={recipe?.grossProfit} />
              )}
            </TitleRow>
            <Meta>
              {isRecipeArchived(recipe) ? null : (
                <span>Cost/portion {formatGbp(recipe?.costPerPortion)}</span>
              )}
              {!isRecipeArchived(recipe) && Number(recipe?.sellingPrice) > 0 ? (
                <>
                  <Separator>·</Separator>
                  <span>Sell £{sellingDisplay}</span>
                </>
              ) : Number(recipe?.sellingPrice) > 0 ? (
                <span>Sell £{sellingDisplay}</span>
              ) : null}
            </Meta>
            {recipe?.description ? (
              <Description>{recipe.description}</Description>
            ) : null}
          </Body>
        </Row>
      </Checkbox>
    </List.Item>
  )
}

const Row = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  width: 100%;
`

const Thumb = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: #f5f5f5;
  border: 1px solid #f0f0f0;
`

const ThumbImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

const ThumbPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  line-height: 11px;
  text-align: center;
  color: #8c8c8c;
  padding: 4px;
`

const Body = styled.div`
  flex: 1;
  min-width: 0;
`

const TitleRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`

const Title = styled.strong`
  font-size: 14px;
  line-height: 20px;
`

const Meta = styled.div`
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 18px;
`

const Separator = styled.span`
  margin: 0 4px;
`

const Description = styled.div`
  margin-top: 4px;
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 18px;
`

export default AddRecipePickerListItem
